/**
 * @interface ConfirmacionPermissions
 * @description Permisos de la confirmación de registros de correo ambiguo (PES-762, M9-H2).
 */
export interface ConfirmacionPermissions {
  /**
   * Ver y confirmar los registros de correo pendientes de confirmar. Lo decide solo el rol, igual que
   * el back (`ValidadorAccesoConfirmacionCorreo`): ninguna actividad del SSO interviene. Empresa ve
   * toda su empresa y el Operativo solo los registros de los que es el responsable; el back lo valida
   * de nuevo (`403 SIN_PERMISO` / `NO_ES_RESPONSABLE`).
   */
  canViewPendientesConfirmar: boolean;
}

/**
 * @function getConfirmacionPermissions
 * @description Calcula los permisos de la confirmación de correo ambiguo.
 * @param {boolean} isEmpresa - El usuario tiene rol Empresa (administrador de la empresa).
 * @param {boolean} isUser - El usuario tiene rol Operativo.
 * @returns {ConfirmacionPermissions} Permisos de la confirmación.
 */
export const getConfirmacionPermissions = (isEmpresa: boolean, isUser: boolean): ConfirmacionPermissions => ({
  canViewPendientesConfirmar: isEmpresa || isUser,
});
